import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughForwardProps = {
  node: ConversationFlowAuditLogEntry<'FORWARD_NODE_VISITED'>;
};

export function RoutedThroughForward({
  node,
}: RoutedThroughForwardProps): JSX.Element {
  return (
    <>
      Forward · <strong>{node.forwarding_type}</strong>
    </>
  );
}
